(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/imageinput/imageinput.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2026 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<div class="row">',
'  <div class="col-md-4">',
'    <label class="btn btn-primary">',
'      <span translate>imageinput.label</span>',
'      <input',
'        type="file"',
'        accept="image/*"',
'        class="image-input"',
'        style="display:none;"',
'      />',
'    </label>',
'  </div>',
'  <div class="col-md-8" ng-show="imageinput.value">',
'    <button ng-click="imageinput.delete()" class="close delete-logo">',
'      &times;',
'    </button>',
'    <img',
'      class="preview img-responsive"',
'      ng-src="data:image/jpeg;base64,{{imageinput.value}}"',
'    />',
'  </div>',
'</div>',
'',''].join("\n"));
  }]);
})();